export const MAX_FREQUENTS_TO_SHOW = 10;
export const ALL_APPS_CUSTOM_TAB_ID = 0;

export const MISSING_CONNECTOR_ICON = "missing_connector_icon";
